import { useEffect } from "react";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import CeoImage from 'styles/images/aboutus/ceo.jpg';
import { Link } from 'react-router-dom';

const CeoResume = () => {

    useEffect(() => {
        // ایمیل ۱
        const e1p1 = "dr20consult";
        const e1p2 = "gmail.com";
        const e1 = `${e1p1}@${e1p2}`;
        const e1Entity = "&#100;&#114;&#50;&#48;&#99;&#111;&#110;&#115;&#117;&#108;&#116;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;";
        document.getElementById("email1").innerHTML =
            `<a href="mailto:${e1}" target="_blank">${e1Entity}</a>`;

        // ایمیل ۲
        // const e2p1 = "dr20consult";
        // const e2p2 = "iran.ir";
        // const e2 = `${e2p1}@${e2p2}`;
        // const e2Entity = "&#100;&#114;&#50;&#48;&#99;&#111;&#110;&#115;&#117;&#108;&#116;&#64;&#105;&#114;&#97;&#110;&#46;&#105;&#114;";
        // document.getElementById("email2").innerHTML =
        //     `<a href="mailto:${e2}" target="_blank">${e2Entity}</a>`;
    }, []);

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <div className={formStyles['text-center']}>
                    <img className={sharedStyles['w-full']} src={CeoImage} alt={"ceo image"} />
                    <span className={ruleStyles['font-weight-800']}>آن ذره که در حساب ناید</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>دکتر مسعود صفّار</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>نظام پزشکی : 65341</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خاک پای مردم عزیز ایران</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>دانش آموخته دانشگاه علوم پزشکی شیراز</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>متولد شهرضا (قمشه)</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>(شهر اساتید گرانقدر دکتر  <span className={sharedStyles['text-green']}>مهدی و حسین الهی قمشه‌ای </span>)</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>۲۷ سال سابقه طبابت</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>حامی موسسات خیریه حمایت از ایتام عطر یاس نبوی</span>
                    <br />
                    <a href="https://yasnabavi.com" target="_blank">www.yasnabavi.com</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خیریه کسا</span>
                    <br />
                    <a href="https://kassa-charity.org" target="_blank">www.kassa-charity.org</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خیریه سالمندان کهریزک</span>
                    <br />
                    <a href="https://kahrizakcharity.com" target="_blank">www.kahrizakcharity.com</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>مدیر مسئول انتشارات ارم شیراز به مدت ۱۲ سال</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>معاون درمان اسبق هلال احمر استان فارس</span>
                    <br />

                    <Link to={`certificates`}>گواهینامه ها (Certificates)</Link>
                    <br />

                    <span className={ruleStyles['font-weight-800']}>ارتباط مستقیم با مديرعامل Dr20</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>از طریق ارسال ایمیل به آدرس‌:
                        
                    </span>
                    <br />
                    <span id="email1"></span>
                    <br />
                    <span id="email2"></span>
                </div>

            </div>
                
        </div>

    );
}

export default CeoResume;